export enum CognitoAppAttribute {
  COUPK = 'COUPK',
  DPP = 'DPP',
  WF = 'WF'
}

export type CognitoUser = {
  apps: CognitoAppAttribute[]
  created: Date
  email: string
  email_verified: boolean
  enabled: boolean
  id: string
  phone_number: string
  phone_number_verified: boolean
  status: string
  updated: Date
}

export enum CognitoMfaType {
  Authenticator = 'SOFTWARE_TOKEN',
  SMS = 'SMS'
}

export type CognitoMfaSettings = {
  enabled: CognitoMfaType[]
  preferred: CognitoMfaType | null
}
